export const STATUS_FILTER_ID = "status";
export const TYPE_FILTER_ID = "type";

// Withdrawn Healthlink products are retired with `active = false` rather than deleted
// (KIN-1698), so they stay in the list. The Status pill reads `active === false`, and
// the filter has to read the same way round: a row with no `active` field reported is
// treated as administrable, not withdrawn.
export const HEALTHLINK_STATUS_FILTER = {
  id: STATUS_FILTER_ID,
  label: "Status",
  type: "single",
  options: [
    { value: "administrable", label: "Administrable" },
    { value: "withdrawn", label: "Withdrawn" },
  ],
};

export const SYSTEM_STATUS_FILTER = {
  id: STATUS_FILTER_ID,
  label: "Status",
  type: "single",
  options: [
    { value: "enabled", label: "Enabled" },
    { value: "disabled", label: "Disabled" },
  ],
};

export const matchesHealthlinkStatus = (row, status) =>
  status === "withdrawn" ? row.active === false : row.active !== false;

export const matchesSystemStatus = (row, status) =>
  status === "disabled" ? row.disabled === true : row.disabled !== true;

// The settings lists carry broad categories (COVID-19, Influenza, PCI, RSV,
// Pneumococcal) rather than the per-product names the Add-vaccine form offers, and on
// the System tab the type is free text, so there is no constant to reuse — the options
// are whatever the rows actually contain.
export const buildTypeFilterOptions = (rows, typeKey) =>
  [...new Set(rows.map((row) => row[typeKey]).filter(Boolean))]
    .sort((first, second) => first.localeCompare(second))
    .map((value) => ({ value, label: value }));
